import { useTranslation } from 'react-i18next';
import SuccessModal from '@/components/SuccessModal';

interface SubscriptionSuccessModalProps {
  isOpen: boolean;
  title?: string;
  description?: string;
  onClose: () => void;
}

const SubscriptionSuccessModal: React.FC<SubscriptionSuccessModalProps> = ({
  isOpen,
  title: titleProp,
  description: descriptionProp,
  onClose,
}) => {
  const { t } = useTranslation();
  const title = titleProp ?? t('js.features.marketplace.subscription_success_modal.title');
  const description =
    descriptionProp ?? t('js.features.marketplace.subscription_success_modal.description');

  return <SuccessModal isOpen={isOpen} title={title} description={description} onClose={onClose} />;
};

export default SubscriptionSuccessModal;
